import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const SideBarWrapper = styled.div`
  @media (max-width: 1150px) {
    display: none;
  }
`;

export const OutbrainWrapper = styled.div`
  min-height: 270px;
  min-width: 300px;
`;

export const SideBarMpuWrapper = styled.div`
  min-height: 620px;
  min-width: 300px;
`;
